import React from "react";
import { cardStatus } from "@/helpers/style.helpers";
import { beepOk, beepWarning } from "@/features/scanners/helpers";
import { ScanActionApiResponseNew } from "@/features/scanners/types";
import { OrderProduct } from "@/types";

// ORDER_NOT_FOUND
// ORDER_PRODUCT_NOT_FOUND
// BAGS_DO_NOT_MATCH

interface ComponentProps {
  data: Partial<ScanActionApiResponseNew> | null;
  orderProduct?: Partial<OrderProduct> | null;
}

const ContentComponent: React.FC<ComponentProps> = ({ data, orderProduct }) => {
  if (!data) return <>Scan een product barcode</>;

  switch (data.code) {
    case "BIN_DATASTRING":
      return <>Scan een product barcode</>;

    case "BAG_AND_PRODUCT_MATCH":
      return (
        <div className="flex flex-col items-center justify-center mb-6">
          <div className="m-4 font-semibold">OK</div>
          <div className="italic">Reparatienummer {orderProduct?.sequence}</div>
          <div className="italic">Onderdeel {orderProduct?.name}</div>
        </div>
      );

    case "BAGS_DO_NOT_MATCH":
      return (
        <div>
          <div>Fout: Verkeerde zak!</div>
          <div>Product: {orderProduct?.name}</div>
        </div>
      );

    case "ORDER_PRODUCT_NOT_FOUND":
      return <div className="m-4 font-semibold">Product niet gevonden</div>;

    case "INVALID_BARCODE_DATA":
      return (
        <>
          Ongeldige barcode of product in barcode.
          <div>{data.message || ""}</div>
        </>
      );

    default:
      return null;
  }
};

export const ProductCard: React.FC<ComponentProps> = (props) => {
  let className = "";

  if (props.data) {
    switch (props.data.code) {
      case "BIN_DATASTRING":
        className = cardStatus.neutral;
        break;
      case "BAG_AND_PRODUCT_MATCH":
        className = cardStatus.info;
        beepOk();
        break;
      case "ORDER_PRODUCT_WITHOUT_BIN":
      case "ORDER_PRODUCT_NOT_FOUND":
      case "BAGS_DO_NOT_MATCH":
      case "INVALID_BARCODE_DATA":
        className = cardStatus.error;
        beepWarning();
        break;
      default:
        className = cardStatus.neutral;
    }
  } else {
    className = cardStatus.neutral;
  }

  return (
    <div
      className={`flex ${className} min-h-40 justify-center items-center m-1 text-2xl rounded-md text-white p-6 text-center`}
    >
      {props.data && <ContentComponent {...props} />}
    </div>
  );
};
